import React from 'react';
import styled from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import { useWhatsappChatStore } from 'store/whatsappChat/useWhatsappChatStore';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';

const FloatingButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #25D366;
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  z-index: 9999;

  &:hover {
    transform: scale(1.1);
  }

  svg {
    color: white;
    font-size: 30px;
  }
`;

const UnreadBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4444;
  color: white;
  border-radius: 50%;
  min-width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  padding: 0 4px;
`;

const FloatingWhatsappButton = () => {
	const { unreadActiveChats, unreadPendingChats } = useMessage();
	const { openWhatsappChat } = useWhatsappChatStore( ( state ) => state.actions );
	const unreadCount = unreadPendingChats + unreadActiveChats;

	return (
		<FloatingButton onClick={() => openWhatsappChat()}>
			<FaWhatsapp />
			{unreadCount > 0 && <UnreadBadge>{unreadCount}</UnreadBadge>}
		</FloatingButton>
	);
};

export default FloatingWhatsappButton;
